import { Fade, makeStyles, Typography } from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import { transitionTimeout } from '../ClaimWizard';
import { ClaimContext } from '../../../../contexts/ClaimContext';
import { separations } from '../../../../constants/StyleConstants';
import MaterialTable from 'material-table';
import { defaultGridOptions, useGridColDefs } from '../../../../utils/GridUtils';
import ClaimsAPI from '../../../../services/ClaimsAPI';
import { LoginContext } from '../../../../contexts/LoginContext';
import { AppContext } from '../../../../contexts/AppContext';

const useStyles = makeStyles(theme => ({
  ...separations,
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  },
}));

const PaymentMethodsGrid = ({ data, loading, onCBUSelection }) => {
  const colDefs = useGridColDefs([{ title: 'CBU', field: 'supplierCBU', valueType: 'numeric' }]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <MaterialTable {...defaultGridOptions} onRowClick={onCBUSelection} columns={colDefs} data={data} isLoading={loading} />
    </div>
  );
};

const CBUSelection = ({ setCBU }) => {
  const classes = useStyles();
  const { idSupplier } = useContext(LoginContext);
  const { showError } = useContext(AppContext);
  const { setStepElements, stepForward } = useContext(ClaimContext);
  const [transIn, setTransIn] = useState(true);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const step = {
      stepNumber: 1,
      backButtonText: 'Cancelar y elegir otro tipo de reclamo',
      transition: {
        enter: () => setTransIn(true),
        exit: () => setTransIn(false),
      },
    };

    setStepElements(step.stepNumber, step);

    setLoading(true);
    ClaimsAPI.getPaymentMethod(idSupplier)
      .then(res => setRows(res))
      .catch(error => showError('Error al cargar los medios de pago'))
      .finally(() => setLoading(false));
  }, []);

  const handleActionMessage = (event, rowData) => {
    setCBU(rowData);
    stepForward();
  };

  return (
    <Fade in={transIn} timeout={transitionTimeout} unmountOnExit>
      <div className={classes.root}>
        <Typography className={classes.bottomSeparation} variant="subtitle2">
          Seleccione una cuenta haciendo click en la fila correspondiente
        </Typography>
        <PaymentMethodsGrid data={rows} onCBUSelection={handleActionMessage} loading={loading} />
      </div>
    </Fade>
  );
};

export default CBUSelection;
